import { codes, types } from 'constants/payment';

export const standardPaymentLabels = {
  [codes.BACS]: 'payments.AmountToPayByBacs',
  [codes.BLUE_VOUCHER]: 'payments.AmountToPayByBlueVoucher',
  [codes.EVOUCHER]: 'payments.AmountToPayByEvoucher',
  [codes.LOYALTY_POINTS]: 'payments.AmountToPayByLoyaltyPoints',
  [codes.SOCIAL_MEDIA]: 'payments.AmountToPayBySocialMedia'
};

export const paymentTypeValues = {
  [types.ON_HOLD_NO_DEPOSIT]: 'put-on-hold-no-deposit',
  [types.ON_HOLD_WITH_DEPOSIT]: 'put-on-hold-with-deposit',
  [types.PAY_BALANCE]: 'pay-in-full'
};
